import esContent from './products.es';

export default {
  ...esContent,
};
